import { useLocation, useNavigate } from 'react-router-dom';
import { PrimaryButton } from '../components/ui/Button/Buttons';
import { PATHS } from '../constants/Paths.constants';
import { AccessDeniedIcon } from '../icons/SvgIcons';

const DEFAULT_CONTENT = {
  title: 'No organization assigned',
  message:
    'Your account isn’t linked to an organization. Ask your administrator to invite you.'
};

// Keyed by the terminal 401 code the auth interceptor passes as `reason`.
const CONTENT_BY_REASON: Record<string, typeof DEFAULT_CONTENT> = {
  ORG_AWAITING_ADMIN: {
    title: 'Organization not set up yet',
    message:
      'Your organization hasn’t been set up yet. One of its administrators needs to sign in first to set it up. Try again once they have.'
  },
  ACCOUNT_DEACTIVATED: {
    title: 'Account deactivated',
    message:
      'Your account has been deactivated. Contact your administrator if you think this is a mistake.'
  }
};

/**
 * Terminal state: the signed-in user's token resolves to no usable organization.
 * Signing in again returns the identical token, so sign-out is the only exit.
 */
export function NoOrganization() {
  const navigate = useNavigate();
  const location = useLocation();
  const reason = new URLSearchParams(location.search).get('reason') ?? '';
  const { title, message } = CONTENT_BY_REASON[reason] ?? DEFAULT_CONTENT;

  return (
    <div className="min-h-screen min-w-screen flex items-center justify-center bg-white">
      <div className="flex flex-row gap-6 text-left">
        {AccessDeniedIcon()}
        <div className="flex flex-col items-start w-[480px] pl-6">
          <h1 className="text-[30px] leading-[36px] font-bold text-purple-900">
            {title}
          </h1>
          <p className="text-base text-gray-500 mb-10">{message}</p>
          <PrimaryButton onClick={() => navigate(PATHS.LOGOUT)}>
            Sign out
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}
